import LeftContentContainer from "../../booking/containers/LeftContentContainer";
import RightContentContainer from "../../booking/containers/RightContentContainer";
import logo from "../../../theme/img/logo/logo2020-500.png";
import MyAccountButtonContainer from "../../../../shared/my_account_button/containers/MyAccountButtonContainer";
// import MyAccountButtonContainer from "../../my_account_button/containers/MyAccountButtonContainer";
import cx from 'classnames';
import { useSelector } from "react-redux";
import * as customerTypes from "../../../data/booking/constants/customer_types";

const App = () => {
    const { data } = useSelector(state => state.account.userSession);

    return (
    <div className={`relative lg:flex lg:h-screen lg:overflow-hidden`}>
        {(!data || data && customerTypes.BUSINESS !== data.type) && (
            <div className={"z-0 lg:w-1/2"} id="leftColumn">
                <LeftContentContainer />
            </div>
        )}
        <div
            className={cx("w-full z-10 lg:overflow-x-hidden lg:overflow-y-scroll lg:shadow-lg", {
                "lg:w-1/2": (!data || data && customerTypes.BUSINESS !== data.type)
            })}
            id="rightColumn"
        >
            <div className={"container mx-auto min-h-screen px-4 py-8 sm:px-6 lg:px-8"}>
                <div className={"flex items-start justify-between lg:flex-row flex-row-reverse"}>
                    <a href={"/"}>
                        <img src={logo} alt="logo" className={"w-24 sm:w-32"} />
                    </a>
                    <MyAccountButtonContainer itemsLeft={false}/>
                </div>

                <div className="mx-auto mt-16 max-w-7xl">
                    <div className="mx-auto flex max-w-3xl flex-col border-b border-[#c5c7ca]">
                        <div>
                            {/* Form Step Content */}
                            <RightContentContainer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)};
export default App;
